// extracted by mini-css-extract-plugin
module.exports = {"usps":"TopMenu_usps__zghKJ","topmenu":"TopMenu_topmenu__v48CZ","align_right":"TopMenu_align_right__32pHL"};